import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@web/components/ui/button.tsx";
import { useMe } from "@web/features/auth/useMe.ts";
import {
  copyProblemReport,
  type ProblemReportInput,
} from "./problemReport.ts";

export function CopyDetailsButton({
  errorId,
  code,
  message,
  action,
  page,
  variant = "secondary",
  size = "sm",
}: {
  errorId: string;
  code: string;
  message: string;
  action?: string;
  page?: string;
  variant?: "secondary" | "outline" | "ghost";
  size?: "sm" | "default";
}) {
  const me = useMe();
  const [busy, setBusy] = useState(false);

  async function onCopy() {
    setBusy(true);
    try {
      const input: ProblemReportInput = {
        errorId,
        code,
        message,
        action,
        page,
        userLabel: me.data?.user.display_name ?? me.data?.user.clerk_user_id ?? null,
      };
      await copyProblemReport(input);
      toast.success("Details copied — paste into WhatsApp");
    } catch {
      toast.error("Couldn't copy details");
    } finally {
      setBusy(false);
    }
  }

  return (
    <Button type="button" variant={variant} size={size} disabled={busy} onClick={() => void onCopy()}>
      Copy details
    </Button>
  );
}
